module.exports = __webpack_public_path__ + "img/美颜首图bg.e15ab039.png";